import { useState } from "react";
import { Check, ChevronsUpDown } from "lucide-react";
import { Popover, PopoverContent, PopoverTrigger } from "./ui/popover";
import { Command, CommandEmpty, CommandGroup, CommandInput, CommandItem, CommandList } from "./ui/command";
import { Avatar } from "./common";

export const AthletePicker = ({ athletes, value, onChange, testid = "athlete-picker", placeholder = "Selecionar atleta", disabled }) => {
  const [open, setOpen] = useState(false);
  const sel = athletes.find((a) => a.user_id === value);
  return (
    <Popover open={open} onOpenChange={setOpen} modal>
      <PopoverTrigger asChild>
        <button type="button" disabled={disabled} data-testid={testid}
          className="flex h-11 w-full items-center justify-between gap-2 rounded-xl border border-[#232B3E] bg-[#0B0E14] px-3 text-left text-sm disabled:opacity-60">
          {sel ? (
            <span className="flex min-w-0 items-center gap-2"><Avatar user={sel} size={24} /><span className="truncate">{sel.name}</span></span>
          ) : <span className="text-[#64748B]">{placeholder}</span>}
          <ChevronsUpDown className="h-4 w-4 shrink-0 text-[#64748B]" />
        </button>
      </PopoverTrigger>
      <PopoverContent className="w-[--radix-popover-trigger-width] p-0 bg-[#121722] border-[#232B3E]" align="start">
        <Command>
          <CommandInput placeholder="Buscar atleta..." data-testid={`${testid}-search`} />
          <CommandList>
            <CommandEmpty>Nenhum atleta encontrado.</CommandEmpty>
            <CommandGroup>
              {athletes.map((a) => (
                <CommandItem key={a.user_id} value={`${a.name} ${a.user_id}`} data-testid={`${testid}-option-${a.user_id}`}
                  onSelect={() => { onChange(a.user_id); setOpen(false); }}>
                  <Avatar user={a} size={24} />
                  <span className="ml-2 flex-1 truncate">{a.name}</span>
                  <span className="text-[11px] text-[#64748B]">{a.level}</span>
                  {value === a.user_id && <Check className="ml-2 h-4 w-4 text-[#E4F222]" />}
                </CommandItem>
              ))}
            </CommandGroup>
          </CommandList>
        </Command>
      </PopoverContent>
    </Popover>
  );
};
